var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefaultCompany(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 144 144",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 144,
    rx: 8,
    fill: "#FAFAFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.96 100.666H54.9067C50.8533 100.666 47.1467 98.6125 45.0133 95.1458C42.88 91.6792 42.6933 87.4658 44.5067 83.8125L49.0933 74.6125C50.5867 71.6258 52.9867 69.7592 55.68 69.4658C58.3733 69.1725 61.12 70.5058 63.2 73.0925L63.7867 73.8392C64.96 75.2792 66.32 76.0525 67.6533 75.9192C68.9867 75.8125 70.2133 74.8525 71.12 73.2258L76.16 64.1325C78.24 60.3725 81.0133 58.4258 84.0267 58.5592C87.0133 58.7192 89.5733 60.9592 91.28 64.9058L99.6267 84.3992C101.173 87.9992 100.8 92.1058 98.64 95.3858C96.5067 98.7192 92.88 100.666 88.96 100.666ZM56.4267 73.4658C56.32 73.4658 56.2133 73.4658 56.1067 73.4925C54.7733 73.6258 53.5467 74.6925 52.6667 76.4258L48.08 85.6258C46.88 87.9992 47.0133 90.7992 48.4 93.0658C49.7867 95.3325 52.24 96.6925 54.9067 96.6925H88.9333C91.5467 96.6925 93.8667 95.4392 95.3067 93.2525C96.7467 91.0658 96.9867 88.4525 95.9467 86.0525L87.6 66.5592C86.5867 64.1592 85.1733 62.6925 83.8133 62.6392C82.56 62.5592 80.9333 63.8925 79.6533 66.1592L74.6133 75.2525C73.0667 78.0258 70.64 79.7592 68 79.9992C65.36 80.2125 62.6667 78.9325 60.6667 76.4258L60.08 75.6792C58.96 74.2125 57.68 73.4658 56.4267 73.4658Z",
    fill: "#D5D5DA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M58.5867 63.334C53.0933 63.334 48.5867 58.854 48.5867 53.334C48.5867 47.814 53.0667 43.334 58.5867 43.334C64.1067 43.334 68.5867 47.814 68.5867 53.334C68.5867 58.854 64.1067 63.334 58.5867 63.334ZM58.5867 47.334C55.28 47.334 52.5867 50.0273 52.5867 53.334C52.5867 56.6407 55.28 59.334 58.5867 59.334C61.8933 59.334 64.5867 56.6407 64.5867 53.334C64.5867 50.0273 61.8933 47.334 58.5867 47.334Z",
    fill: "#D5D5DA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultCompany);
export default __webpack_public_path__ + "static/media/defaultCompany.602270ba3ff4baf302994e626d6fe983.svg";
export { ForwardRef as ReactComponent };